<div class="app-loader" *ngIf="loader.isLoading()">
  <div class="backdrop"></div>
  <img class="spinner" [src]="image" loading="lazy" alt="Loading..." />
</div>
